import { initializeCustomerService } from './utils/CustomerService'
import { showToast } from 'vant'
import 'vant/es/toast/style'
import { createAppInstance } from './app'
import { useSiteConfigStore } from './stores/SiteConfig'
import { useAuthStore } from './stores/UserAuth'
// 导入全局样式
import '@/assets/styles/main.scss'
// 注意：资源路径修复插件已在 app.js 中全局注册
// 服务端 (server.js) 已处理 CDN 路径替换，客户端无需重复扫描

initializeCustomerService(message => showToast(message))

createAppInstance().then(({ app, router }) => {

  if (window.__INITIAL_STATE__) {
    app.config.globalProperties.$store = window.__INITIAL_STATE__

    // 恢复服务端的认证状态
    if (window.__INITIAL_STATE__.auth) {
      const authStore = useAuthStore()
      authStore.$patch(window.__INITIAL_STATE__.auth)
    }
  }

  if (window.__INITIAL_SITE_CONFIG__) {
    const siteConfigStore = useSiteConfigStore()
    siteConfigStore.$patch(window.__INITIAL_SITE_CONFIG__)
  }

  // 读取SSR配置 - 从 window.__INITIAL_STATE__ 中获取
  const ssrConfig = window.__INITIAL_STATE__?.ssrConfig || { mode: 'spa' };

  // 在完全SSR模式下，每次路由变化都触发完整页面加载
  if (ssrConfig.mode === 'full') {
    // 标记是否已经初始化完成
    let isInitialized = false;

    // 记录当前路径，避免初始加载时重定向
    const initialPath = window.location.pathname;

    router.beforeEach((to, from, next) => {
      // Vue Router 4 中，初始加载时 from.name 为 null
      // 初始导航时应该无条件放行，避免触发刷新
      if (from.name === null || !isInitialized) {
        // 标记初始化完成
        isInitialized = true;
        next();
        return;
      }

      // 如果是相同路径，直接放行
      if (to.path === from.path) {
        next();
        return;
      }

      // 触发完整页面加载，走服务端渲染
      // 使用 replace 而不是 href，避免在浏览器历史中留下记录
      window.location.replace(to.fullPath);

      // 阻止客户端路由继续
      next(false);
    });
  }

  router.isReady().then(() => {
    app.mount('#app')
    // 注意：不再执行 fixAllResourcePaths
    // 原因：server.js 已完成 CDN 路径替换，客户端重复扫描会导致 hydration 后 DOM 变化，引起闪屏
  })
})
